import AppRouter from "./router/AppRouter";
import "./App.css";

function App() {
  return (
    <div>
      <AppRouter />
    </div>
  );
}

export default App;
